import { render, staticRenderFns } from "./comments_item.vue?vue&type=template&id=86c74f30&scoped=true&"
import script from "./comments_item.vue?vue&type=script&lang=js&"
export * from "./comments_item.vue?vue&type=script&lang=js&"
import style0 from "./comments_item.vue?vue&type=style&index=0&id=86c74f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c74f30",
  null
  
)

export default component.exports